import { inject, Injectable } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  
  private unleash = inject(UnleashService);

  // Check if a feature flag is enabled (synchronous) -for one-time checks on  component initialization or method calls
  isEnabled(flagName: string): boolean {
    const result = this.unleash.isEnabled(flagName);
    // console.log(`Feature flag '${flagName}':`, result);
    return result;
  }

  // Check if a feature flag is enabled (reactive/observable) - for real-time UI updates without page refresh
  // isEnabled$(flagName: string): Observable<boolean> {
  //   return this.unleash.isEnabled$(flagName);
  // }
}
